<!--
 * @Author: jordan.lu jordan.lu@oppo.com
 * @Date: 2024-03-04 16:29:44
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-03-28 17:36:52
 * @FilePath: \community-frontend\src\views\gallery\web\components\galleryImgPreview.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Teleport to="body">
    <van-overlay :show="visible" z-index="3000">
      <div class="prev-container" v-if="visible">
        <div class="prev-main" @click="hidePreview">
          <div class="prev-header">
            <svg-icon name="icon-close-bg" class="close" />
            <div class="prev-img-detail" v-if="avatarInfo?.id">
              <!-- 作者信息 -->
              <div class="prev-author">
                <Avatar
                  :avatarInfo="avatarInfo"
                  :size="48"
                  :iconSize="13"
                  @click="hidePreview"
                >
                </Avatar>
                <div class="name-follow">
                  <router-link
                    class="username"
                    :to="{ name: 'user', params: { id: avatarInfo.id } }"
                  >
                    {{ avatarInfo.userName }}
                  </router-link>
                  <Follow
                    class="follow noclose"
                    :uid="avatarInfo.id"
                    :relation="relation"
                    @change="onChangeFollowStatus"
                  >
                  </Follow>
                </div>
              </div>
              <div class="prev-like">
                <ObButton
                  :class="'like-btn noclose ' + (praised ? 'like' : 'unlike')"
                  @click="likeRef.onClickIcon()"
                >
                  <Like
                    ref="likeRef"
                    :uid="avatarInfo.id"
                    :id="tid"
                    :count="praiseCount"
                    :status="praised"
                    @update:status="onChangeLikeStatus"
                  />
                  <span class="like-count">
                    {{
                      $numFormat(praiseCount) + ' ' + $t('like', praiseCount)
                    }}
                  </span>
                </ObButton>
                <router-link :to="{ name: 'thread', params: { id: tid } }" v-if="showThreadEntry">
                  <ObButton
                    class="view-detail"
                    :text="$t('gallery.viewDetails')"
                    backgroundColor="rgba(255,255,255,.95)"
                    fontColor="rgba(0, 0, 0, .95)"
                  >
                  </ObButton>
                </router-link>
              </div>
            </div>
          </div>

          <div class="prev-body">
            <div class="prev-hand">
              <svg-icon
                name="icon-prev"
                class="switch-icon noclose left"
                :class="[!showIndex && 'disabled']"
                @click="switchImg('prev')"
              />
            </div>
            <!-- 图片展示区 -->
            <div class="prev-area noclose">
              <div
                class="live-box"
                @click="toPlayLive"
                v-show="imgList[showIndex]?.type === 5"
              >
                <svg-icon name="icon-live"></svg-icon>
                <p>{{ $t('liveName') }}</p>
              </div>
              <img
                v-show="showImg && !showLiveVideo"
                ref="imgRef"
                :src="imgList[showIndex]?.bigSize"
                :class="'prev-img ' + (zoomLevel > 1 ? 'dragable' : '')"
                :style="{
                  transform: `scale(${zoomLevel}) rotate(${rotateDeg}deg) translate(${dragX}px, ${dragY}px)`
                }"
                @mousedown="startDrag"
                @mousemove="drag"
                @mouseup="endDrag"
                @mouseleave="endDrag"
                @load="imgLoaded"
              />
              <video
                v-show="showLiveVideo"
                id="live-video"
                muted
                :src="imgList[showIndex]?.microVideo"
              ></video>
              <svg-icon
                v-show="loading"
                name="icon-media-loading"
                class="loading"
              />
            </div>
            <div class="prev-hand">
              <svg-icon
                name="icon-next"
                class="switch-icon noclose right"
                :class="[showIndex === (imgList.length - 1) && 'disabled']"
                @click="switchImg('next')"
              />
            </div>
          </div>

          <!-- 图片操作区 -->
          <div class="prev-footer">
            <div class="prev-toolbar noclose">
              <!-- 查看原图按钮 -->
              <div
                v-show="
                  !imgList[showIndex]?.loadedOrigin && !imgList[showIndex]?.type
                "
                class="toolbar-button button-text origin-button"
                @click="viewOrigin"
              >
                {{ $t('gallery.viewOrigin') }}
              </div>
              <div
                class="toolbar-button button-text origin-button"
                @click="downOrigin(imgList[showIndex]?.origin)"
                v-if="
                  imgList[showIndex]?.type === 5 && imgList[showIndex]?.origin
                "
              >
                {{ $t('gallery.downOrigin') }}
              </div>
              <svg-icon
                :class="
                  'toolbar-button' +
                  (zoomLevel >= zoomMax ? ' disable-tool' : '')
                "
                name="icon-scaleup"
                @click="zoom(zoomStep)"
              />
              <svg-icon
                :class="
                  'toolbar-button' +
                  (zoomLevel <= zoomMin ? ' disable-tool' : '')
                "
                name="icon-scaledown"
                @click="zoom(-zoomStep)"
              />
              <svg-icon
                class="toolbar-button"
                name="icon-rotate-left"
                @click="rotate(-rotateStep)"
              />
              <svg-icon
                class="toolbar-button"
                name="icon-rotate-right"
                @click="rotate(rotateStep)"
              />
              <div class="toolbar-button button-text">
                <slot name="pagetitle">
                  <span>{{ showIndex + 1 }} / {{ imgList.length }}</span>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <!-- 侧边栏动画 -->
        <div class="prev-sidebar">
          <div class="thumbnail-block">
            <slot name="sidebar">
              <el-image
                v-if="imgList?.length > 1"
                v-for="(item, index) in imgList"
                :key="index"
                :src="item.thumbnail"
                fit="contain"
                class="thumbnail"
                :class="[index == showIndex && 'active']"
                @click="onChooseThumbnail(index)"
                lazy
              />
            </slot>
          </div>
        </div>
      </div>
    </van-overlay>
  </Teleport>
</template>

<script setup>
import { blobToBase64 } from '@/utils';
const props = defineProps({
  previewList: {
    type: Array,
    default: []
  },
  visible: {
    type: Boolean,
    default: false
  },
  previewIndex: {
    type: Number,
    default: 0
  },
  authorInfo: {
    type: Object,
    default: null
  },
  tid: {
    type: [Number, String],
    default: null
  },
  praiseCount: {
    type: Number,
    default: 0
  },
  praised: {
    type: Boolean,
    default: false
  },
  showThreadEntry: {
    type: Boolean,
    default: true
  },
  showDownloadBtn: {
    type: Boolean,
    default: true
  }
});

const { proxy } = getCurrentInstance();

const imgRef = ref(null);
const likeRef = ref(null);
const avatarInfo = ref(null);
const imgList = ref([]);
const showIndex = ref(0);
const loading = ref(false);
const showImg = ref(false);
const showSidebar = ref(true);
// 控制缩放
const zoomInit = 1;
const zoomLevel = ref(zoomInit);
const zoomMax = 4;
const zoomMin = 1;
const zoomStep = 0.2;
// 图片旋转
const rotateInit = 0;
const rotateDeg = ref(rotateInit);
const rotateStep = 90;
// 图片拖拽
const draging = ref(false);
const dragX = ref(0);
const dragY = ref(0);
let lastX = 0;
let lastY = 0;

// 关注状态
const relation = ref(0);

const emit = defineEmits(['update:visible', 'changeFollow', 'changeLike', 'update:previewIndex', 'next']);

const hidePreview = (e) => {
  // 有noclose类标记的元素不会触发关闭遮罩层
  if (!e.target.closest('.noclose')) {
    emit('update:visible', false);
  }
};

const showLiveVideo = ref(false);

const mediaType = ref(-1);

const onChooseThumbnail = (index) => {
  showIndex.value = index
  switchImg()
}

const switchImg = (action, anchor = true) => {
  if (!imgList.value?.length) return

  if ((action === 'prev' && !showIndex.value) || (showIndex.value >= (imgList.value.length - 1) && action === 'next')) return

  if ((action === 'next')) {
    showIndex.value ++
  }
  if (action === 'prev') {
    showIndex.value --
  }
  mediaType.value = imgList.value[showIndex.value].type;
  setTimeout(() => {
    document.querySelector('.thumbnail.active')?.scrollIntoView({
      block: 'center',
      behavior: anchor ? 'smooth' : 'auto'
    })
  }, 500)
  emit('update:previewIndex', showIndex.value)
  showImg.value = false;
  loading.value = true;
  zoomLevel.value = zoomInit;
  rotateDeg.value = rotateInit;
  dragX.value = 0;
  dragY.value = 0;
};

// 缩放图片
const zoom = (step) => {
  if (showLiveVideo.value) return;
  let level = zoomLevel.value + step;
  if (level > zoomMax) level = zoomMax;
  if (level < zoomMin) level = zoomMin;
  zoomLevel.value = level;
};

// 旋转图片
const rotate = (step) => {
  if (showLiveVideo.value) return;
  rotateDeg.value += step;
};

// 拖拽实现
const startDrag = (e) => {
  e.preventDefault();

  if (zoomLevel.value === zoomInit) {
    return;
  }
  draging.value = true;
  lastX = e.clientX;
  lastY = e.clientY;
};

// 坐标变换，返回旋转后移动的距离
const transformCoordinates = (x, y, angle) => {
  angle = angle % 360 >= 0 ? angle % 360 : (angle % 360) + 360;
  let transX = x;
  let transY = y;
  switch (angle) {
    case 90:
      transX = y;
      transY = -x;
      break;

    case 180:
      transX = -x;
      transY = -y;
      break;

    case 270:
      transX = -y;
      transY = x;
      break;
  }
  return { transX, transY };
};

const drag = (e) => {
  // 必须要加这个,不然会无法触发mouseup事件
  // TODO 做个笔记研究这个
  e.preventDefault();

  if (!draging.value) return;

  let transCoor = transformCoordinates(
    e.clientX - lastX,
    e.clientY - lastY,
    rotateDeg.value
  );
  dragX.value += transCoor.transX;
  dragY.value += transCoor.transY;

  // 更新上次结束的位置，如果少了这一步，移动量会不准
  lastX = e.clientX;
  lastY = e.clientY;
};

const endDrag = (e) => {
  e.preventDefault();
  draging.value = false;
};

const imgLoaded = () => {
  showImg.value = true;
  loading.value = false;

  // 如果是实况图 先播放视频 隐藏封面图
  showLiveVideo.value = false;
  if (mediaType.value === 5) {
    toPlayLive();
  }

  let showItem = imgList.value[showIndex.value];
  // 加载的是原图，把查看原图按钮隐藏
  if (showItem.bigSize === showItem.origin) {
    imgList.value[showIndex.value].loadedOrigin = true;
  }
};

// 查看原图
const viewOrigin = () => {
  loading.value = true;
  imgList.value[showIndex.value].bigSize =
    imgList.value[showIndex.value].origin;
};

// 下载原图
const downloading = ref(false);
const downOrigin = (link, picName) => {
  if (downloading.value) return;
  downloading.value = true;
  const img = new Image();
  img.src = link;
  img.setAttribute('crossorigin', 'anonymous');
  img.onload = async function () {
    const blobRes = await fetch(link).then((res) => res.blob());
    const base64 = await blobToBase64(blobRes);
    const url = document.createElement('a');
    url.download = 'download';
    url.href = base64;
    url.click();
    downloading.value = false;
  };
};

// 关注/取消关注 后同步更新关注状态
const onChangeFollowStatus = (e) => {
  relation.value = e.relation;
  emit('changeFollow', e.relation);
};

// 点赞/取消点赞 状态变更
const onChangeLikeStatus = (val) => {
  emit('changeLike', val);
};

const toPlayLive = () => {
  if (showLiveVideo.value) return;
  showLiveVideo.value = true;
  const videoElement = document.getElementById('live-video');
  videoElement
    .play()
    .then(() => {
      // console.log(`autoplay well`);
    })
    .catch((e) => {
      // console.log(`autoplay fail, wait for first click`);
    });
  videoElement.onended = () => {
    showLiveVideo.value = false;
  };
};

watch(
  () => [props.visible, props.previewList],
  ([inputVisible, previewList]) => {
    if (inputVisible) {
      loading.value = true;
      // 隐藏滚动条
      document.body.style.overflow = 'hidden';
      showSidebar.value = true;
      // showIndex.value = null; // 这里设为null，保证展示 loading 状态
      avatarInfo.value = { ...props.authorInfo };
      relation.value = props.authorInfo?.relation;
      imgList.value = previewList.map((e) => {
        // 实况图
        if (e?.type && e?.type === 5) {
          return {
            type: e.type,
            thumbnail: proxy.$formatImg(e.coverImage, 80), // 侧边栏缩略图
            bigSize: proxy.$formatImg(e.coverImage, 1000, '', false), // 压缩大图
            origin: e.url, // 原图
            microVideo: e.microVideoTranscodeInfo?.[0].url || e.microVideo // 视频动图
          };
        }
        // 普通图
        if(e?.includes('?x-ocs-process=')){
          e = e.split('?x-ocs-process=')[0]
        }
        return {
          thumbnail: proxy.$formatImg(e, 80), // 侧边栏缩略图
          bigSize: proxy.$formatImg(e, 1000, '', false), // 压缩大图
          origin: e, // 原图
          loadedOrigin: false // 是否加载过原图
        };
      });
      showIndex.value = props.previewIndex
      switchImg();
    } else {
      avatarInfo.value = null;
      document.body.style.overflow = 'auto';
    }
  }, {
    immediate: true,
    deep: true
  }
);

defineExpose({
  switchImg,
  imgLoaded,
})
</script>

<style lang="postcss" scoped>
.prev-container {
  height: 100%;
  width: 100%;
  display: flex;
  background: rgba(17, 17, 17, 1);

  --hand-width: 126px;

  .prev-main {
    height: 100%;
    /* width: calc(100vw - var(--sidebar-width)); */
    width: 100%;

    .svg-icon {
      cursor: pointer;
    }
  }

  .prev-header {
    /* width: calc(100vw - var(--sidebar-width)); */
    height: 120px;
    display: flex;
    justify-content: center;
    position: relative;

    .close {
      position: absolute;
      border-radius: 100px;
      top: 20px;
      left: 24px;
      width: 32px;
      height: 32px;
      background: rgba(255, 255, 255, 0.2);
    }

    .prev-img-detail {
      width: calc(100% - var(--hand-width) * 2);
      height: 48px;
      margin: 46px 0 20px;
      display: flex;
      justify-content: space-between;

      .prev-author {
        height: 100%;
        width: fit-content;
        display: flex;
        align-items: center;
        .name-follow {
          display: flex;
          flex-flow: column nowrap;
          justify-content: space-between;
          height: 100%;
          margin-left: 4px;
          color: var(--text-primary-reverse);
          .username {
            display: block;
            color: var(--text-primary-reverse);
            font-size: 14px;
            margin: 0 0 2px;
            line-height: 19.88px !important;
          }

          .username:hover {
            color: var(--text-secondary-reverse);
            cursor: pointer;
          }

          .follow {
            font-size: 10px;
            background-color: transparent;
            height: 22px !important;
            border: 1px solid rgba(255, 255, 255, 0.55);
            /* 覆盖外部的icon按钮尺寸 */
            --icon-button-size: 22px !important;

            :deep(span) {
              /* height:18px; */
              display: block;
            }

            :deep(.svg-icon) {
              height: 18px;
            }
          }

          .follow:hover {
            opacity: 0.4;
          }
        }
      }

      .prev-like {
        height: 100%;
        width: fit-content;
        display: flex;
        align-items: center;
        margin-left: 40px;

        button {
          height: 34px;
          display: flex;
          align-items: center;

          .like-count {
            margin: 0 8px;
            line-height: 16px !important;
            /* height: 24px; */
            /* 不能选中 */
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }

          .svg-icon {
            color: #fff;
          }
        }

        .like-btn {
          padding: 0 24px;
        }

        .like {
          background-color: rgba(213, 213, 213, 1);
          color: var(--text-primary);
        }

        .view-detail {
          font-size: 16px;
          padding: 0 24px;
          margin-left: 10px;

          :deep(span) {
            /* 不能选中 */
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
        }

        .view-detail:hover {
          opacity: 0.8;
        }
      }
    }

    .sidebar-handle {
      height: 52px;
      width: 52px;
      position: absolute;
      top: 16px;
      right: 0px;
      color: white;
    }
  }

  .prev-body {
    display: flex;
    /* width: calc(100vw - var(--sidebar-width)); */
    height: calc(100vh - 240px);

    .prev-hand {
      width: var(--hand-width);
      height: 100%;
      display: flex;
      align-items: center;

      .svg-icon {
        cursor: pointer;
        width: 52px;
        height: 52px;
      }

      .switch-icon {
        border-radius: 100px;
        background: rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 0.95);
      }
      .disabled {
        cursor: not-allowed;
        color: rgba(255, 255, 255, 0.2);
      }

      .left {
        margin-left: 50px;
        margin-right: 24px;
      }

      .right {
        margin-left: 24px;
        margin-right: 50px;
      }
    }

    .prev-area {
      width: calc(100% - var(--hand-width) * 2);
      background: rgba(255, 255, 255, 0.08);
      background: rgba(255, 255, 255, 0.08);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      position: relative;

      .live-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: 99;
        top: 24px;
        left: 24px;
        background-color: rgba(255, 255, 255, 0.15);
        font-size: 14px;
        color: #fff;
        padding: 2px 4px;
        border-radius: 2px;
        cursor: pointer;
        .icon-live {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }
        p {
          height: 20px;
          line-height: 20px !important;
        }
      }

      #live-video {
        max-height: 100%;
      }

      .prev-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        margin: auto;

        /* 不能选中 */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .dragable {
        cursor: grab;
      }

      .loading {
        /* 固定在屏幕最中间 */
        position: absolute;
        top: calc(100% / 2 - 12);
        left: calc(100% / 2 - 12);
        height: 24px;
        width: 24px;
        color: white;
        animation: rotate 1s linear infinite;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  .prev-footer {
    /* width: calc(100vw - var(--sidebar-width)); */
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    .prev-toolbar {
      display: flex;

      .toolbar-button {
        padding: 4px 15px;
        background: rgba(255, 255, 255, 0.2);
        color: white;
        border-radius: 4px;
        margin-right: 16px;
      }

      .disable-tool {
        color: rgba(255, 255, 255, 0.2);
      }

      .svg-icon {
        height: 22px;
        width: 26px;
      }

      .toolbar-button:last-child {
        margin-right: 0;
        background: rgba(255, 255, 255, 0.2);
        font-size: 14px;
      }

      .button-text {
        display: flex;
        align-items: center;
        color: white;

        /* 不能选中 */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .origin-button {
        padding: 0 30px 2px 30px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .prev-sidebar {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;

    /* 隐藏滚动条 */
    scrollbar-width: none;
    -ms-overflow-style: none;
    .thumbnail-block {
      position: relative;
      display: flex;
      flex-flow: column;
      align-items: flex-end;
      width: 94px;
      padding: 24px 16px 128px 12px;
      box-sizing: border-box;
      .thumbnail {
        margin-bottom: 8px;
        border-radius: 6px;
        cursor: pointer;
        opacity: 0.4;
        /* 不能选中 */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .thumbnail:hover {
        opacity: 1;
      }

      .active {
        width: 78px;
        opacity: 1;
      }
    }
  }

  .prev-sidebar::-webkit-scrollbar {
    display: none;
  }

  .sidebar-enter-active,
  .sidebar-leave-active {
    transition: width 0.3s;
  }

  .sidebar-enter-from,
  .sidebar-leave-to {
    width: 0;
  }
}
</style>
